export default __webpack_public_path__ + "static/media/link1.32ec91a7.png";